import { motion, useMotionValue, useTransform } from "framer-motion";
import { Phone, MessageSquare } from "lucide-react";

/**
 * Wraps children in a horizontally-draggable card.
 * Swipe right (>= 100px) → onSwipeRight  (green Call background revealed)
 * Swipe left  (<= -100px) → onSwipeLeft   (green WhatsApp background revealed)
 * Card snaps back to 0 on release.
 */
export default function SwipeableLeadCard({ leadId, onSwipeRight, onSwipeLeft, children }) {
  const x = useMotionValue(0);
  const rightOpacity = useTransform(x, [0, 60, 100], [0, 0.6, 1]);
  const leftOpacity  = useTransform(x, [-100, -60, 0], [1, 0.6, 0]);

  const handleDragEnd = (_e, info) => {
    if (info.offset.x >= 100 && onSwipeRight) onSwipeRight();
    else if (info.offset.x <= -100 && onSwipeLeft) onSwipeLeft();
  };

  return (
    <div className="relative overflow-hidden rounded-2xl" data-testid={`swipe-wrap-${leadId}`}>
      {/* Left background — call (revealed by swipe right) */}
      <motion.div
        style={{ opacity: rightOpacity }}
        className="absolute inset-0 flex items-center justify-start pl-5 bg-emerald-500 rounded-2xl">
        <div className="flex items-center gap-2 text-slate-900 font-bold">
          <Phone className="w-5 h-5"/> Call
        </div>
      </motion.div>
      {/* Right background — whatsapp (revealed by swipe left) */}
      <motion.div
        style={{ opacity: leftOpacity }}
        className="absolute inset-0 flex items-center justify-end pr-5 bg-emerald-600 rounded-2xl">
        <div className="flex items-center gap-2 text-white font-bold">
          <MessageSquare className="w-5 h-5"/> WhatsApp
        </div>
      </motion.div>
      {/* Draggable card */}
      <motion.div
        drag="x"
        dragConstraints={{ left: 0, right: 0 }}
        dragElastic={0.6}
        style={{ x }}
        onDragEnd={handleDragEnd}
        className="relative touch-pan-y"
        data-testid={`swipeable-${leadId}`}>
        {children}
      </motion.div>
    </div>
  );
}
